import { render, staticRenderFns } from "./eventsBell.vue?vue&type=template&id=0f684dd8&"
import script from "./eventsBell.vue?vue&type=script&lang=js&"
export * from "./eventsBell.vue?vue&type=script&lang=js&"
import style0 from "./eventsBell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports